import React from "react";

export default function App() {
  const links = [
    { title: "REPORT SEASONAL", url: "https://drive.google.com/drive/folders/19hqOG0OBuVJq6vyNjgItiimHMAnOugqc?usp=sharing"},
    { title: "REPORT SUKANDA FAIR", url: "https://drive.google.com/drive/folders/1qqqayyqq9EqRwj_gUBkpZmBBho_AcRTU?usp=sharing" },
    { title: "REPORT JUSAMI", url: "https://drive.google.com/drive/folders/1vQGC_n1AtKhH-DeXo1IgwZu2j7j_39gP?usp=sharing" },
    { title: "REPORT WEEKLY", url: "https://drive.google.com/drive/folders/129ZdDpMKNsHxgfojW9PHPtowtOLhbIyt?usp=sharing" },
    { title: "REPORT SAMPLING", url: "https://drive.google.com/drive/folders/1RB17cvdBosLa9aR8HYpAkv2XxWQTWODH?usp=sharing" },
    { title: "SHARE OF SPACE", url: "https://docs.google.com/spreadsheets/d/1AyyPh4ccsorJ9O2LD_B61sh5sCDCRRVkSSzIQJrKVUM/edit?usp=sharing" },
  ];

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6" style={{backgroundColor:'#2b236f'}}>
      <div className="max-w-md w-full  backdrop-blur-xl shadow-2xl rounded-3xl p-8 text-center border border-white/30" style={{backgroundColor:'#165db1'}}>

        {/* Foto Profil */}
        <div className="flex justify-center">
          <img
            src="/sukanda.png"
            alt="profile"
            className="w-28 h-28  object-cover shadow-xl"
          />
        </div>

        <h2 className="text-2xl font-bold text-white mt-4 mb-6 drop-shadow-lg">
          Report Seasonal Sukanda 
        </h2>

        {/* Link Buttons */}
        <div className="space-y-4">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white/90 text-black py-3 rounded-xl text-sm font-semibold hover:bg-white hover:text-gray-900 transition-all p-2 shadow-md backdrop-blur-md border border-white/30"
            >
              {link.title}
            </a>
          ))}
        </div>

      </div>
    </div>
  );
}
